export const PaymentStatusMapping = {
  paid: "paid",
  not_paid: "not paid",
};

export const MessageStatusMapping = {
  new: "new",
  in_progress: "in progress",
  resolved: "resolved",
};



export interface OrderModel {
  customer: any
  status: string
  paymentStatus: string
  addOns: AddOn[]
  _id: string
  service: Service
  plateNumber: string
  company: Company
  employee: any
  totalCost: number
  createdBy: string
  updatedBy: string
  statusHistory: StatusHistory[]
  createdAt: string
  updatedAt: string
}

export interface AddOn {
  _id: string
  name: string
  price: number
}

export interface Service {
  _id: string
  name: string
  price: number
}

export interface Company {
  _id: string
  name: string
}

export interface StatusHistory {
  previousStatus: string
  newStatus: string
  updatedBy: UpdatedBy
  changedAt: string
}

export interface UpdatedBy {
  _id: string
  email: string
}
